// Module
var code = `{{#sidebarData}}

<a
  id="{{menuData.menuId}}"
  data-channel="ROUTE"
  data-item-id="{{itemId}}"
  data-page-id="{{menuData.pageId}}"
  data-stage="{{menuData.stage}}"
  data-container="{{menuData.container}}"
  data-section="{{menuData.section}}"
  data-topic="{{menuData.topic}}"
  data-subtopic="{{menuData.subtopic}}"
  data-event-prevent-default="true"
  data-nav-selector="{{navSelector}}"
  data-class-method=""
  data-is-menu-link="true"
  data-code-block-id="{{codeBlockId}}"
  data-code-block-data-section="types"
  data-example-title="{{exampleTitle}}"
  data-method-name="{{methodName}}"
  class="menu-drawer-link menu-item-{{menuData.itemType}} page-{{menuData.pageId}} item-{{menuData.pageId}}-{{menuData.stage}}-{{section}}-{{topic}}-{{subtopic}}  nav-level-{{level}} {{sidebarSection}} {{sidebarIndent}}"
  href="{{menuData.url}}"
  >{{sidebarTitle}}{{text}}</a
>

{{/sidebarData}}
`;
// Exports
module.exports = code;